export const adminData = {
  eventFieldsDefault: [
    // {
    //   name: 'Zone name',
    //   name_wfh: 'Project',
    //   key: 'place_name'
    // },   
    {
      name: 'Cam name',
      name_wfh: 'Agent',
      key: 'cam_name'
    },
    {
      name: 'Event name',    
      name_wfh: 'Event name',
      key: 'name'
    },
    {
      name: 'Priority',
      key: 'priority'
    },
    {
      name: 'Image',
      key: 'image'
    }
  ],
  eventFields: [
    // {
    //   name: 'Zone ID',
    //   name_wfh: 'Project ID',
    //   key: 'placeId'
    // },
    // {
    //   name: 'Zone name',
    //   name_wfh: 'Project',
    //   key: 'place_name'
    // },
    {
      name: 'Cam ID',
      name_wfh: 'Cam ID',
      key: 'camId'
    },
    {
      name: 'Cam name',
      name_wfh: 'Cam Name',
      key: 'cam_name'
    },
    {
      name: 'Event name',
      name_wfh: 'Event Name',
      key: 'name'
    },
    {
      name: 'Event time',
      name_wfh: 'Event Date Time',
      key: 'event_time'
    },
    {
      name: 'Priority',
      key: 'priority'
    },
    // {
    //   name: 'Type',
    //   name_wfh: 'Violation Type',
    //   key: 'type'
    // },
    {
      name: 'Tags',
      key: 'tags'
    },
    // {
    //   name: 'Face ID',
    //   key: 'faces'
    // },
    {
      name: 'Image',
      key: 'image'
    }
  ],
  eventFields2: [
    {
      name: 'Zone ID',
      name_wfh: 'Project ID',
      key: 'placeId'
    },
    // {
    //   name: 'Zone name',
    //   name_wfh: 'Project',
    //   key: 'place_name'
    // },
    {
      name: 'Cam ID',
      name_wfh: 'Cam ID',
      key: 'camId'
    },
    {
      name: 'Cam name',
      name_wfh: 'Cam Name',
      key: 'cam_name'
    },
    {
      name: 'Event time',
      name_wfh: 'Event Date Time',
      key: 'event_time'
    },
    {
      name: 'Event name',
      name_wfh: 'Event Name',
      key: 'name'
    },
    {
      name: 'Priority',
      key: 'priority'
    },
    // {
    //   name: 'Type',
    //   name_wfh: 'Violation Type',
    //   key: 'type'
    // },
    {
      name: 'Tags',
      key: 'tags'
    },
    {
      name: 'Image',
      key: 'image'
    }
  ],
  eventPriorities: [
    {
      name: 'Very low',
      keyLabel: 0,
    },
    {
      name: 'Low',
      keyLabel: 1,
    },
    {
      name: 'Medium',
      keyLabel: 2,
    },
    {
      name: 'High',
      keyLabel: 3,
    },
    {
      name: 'Very High',
      keyLabel: 4,
    },
  ],
  eventImages: [
    {
      name: 'Primary Image',
      key: 'primaryImage',
    },
    {
      name: 'Secondary Image',
      key: 'secondaryImage'
    },
  ],
  priority: [
    'Very low','Low','Medium','High','Very High'
  ],
  priorityValues: [
    {
      label: 'VERY LOW',
      value: 0,
      color: '#c6ff97'
    },{
      label: 'LOW',
      value: 1,
      color: '#63ff2c'
    },
    {
      label: 'MEDIUM',
      value: 2,
      color: '#fff631'
    },
    {
      label: 'HIGH',
      value: 3,
      color: '#ffa716'
    },
    {
      label: 'VERY HIGH',
      value: 4,
      color: '#ff3707'
    }
  ],
  searchValues:[
    {
      key:"search"
    }
  ],
  eventData: [
    {
      label: 'Very low and above',
      value: 0
    },
    {
      label: 'Low and above',
      value: 1
    },
    {
      label: 'Medium and above',
      value: 2
    },
    {
      label: 'High and above',
      value: 3
    },
    {
      label: 'Very High and above',
      value: 4
    },
  ],
  role: [
    {
      name: 'ADMIN',
    },
    {
      name: 'REGULAR',
    },
    {
      name: 'RESIDENT',
    },
  ],

  userNotificationFields: [
    {
      name: 'User Name',
      key: 'userName'
    },
    {
      name: 'Tag',
      key: 'tag'
    },
    {
      name: 'User Image',
      key: 'userImage'
    },
    {
      name: 'Menu',
      key: 'menu'
    }
  ],
  violationFieldsDefault: [
    // {
    //   name: 'Zone name',
    //   name_wfh: 'Project',
    //   key: 'place_name'
    // },   
    {
      name: 'Cam name',
      name_wfh: 'Agent',
      key: 'cam_name'
    },
    {
      name: 'Event name',
      name_wfh: 'Event name',
      key: 'name'
    },
    {
      name: 'Date',
      key: 'event_time'
    },
    {
      name: 'Image',
      key: 'image'
    },
    {
      name: 'Action For Violation',
      key: 'actionForViolation'
    },
    {
      name: 'Reason For Violation',
      key: 'reasonForViolation'
    },
    {
      name: 'Confirmation',
      key: 'confirmation'
    },
    {
      name: 'Purge',
      key: 'purge'
    }
  ],
}